export default {"src":"/_next/static/media/md-bubble-chart-own.9ddc98cb.svg","height":32,"width":32};